import React, { useState } from 'react';
import moment from 'moment/min/moment-with-locales';
import { useTranslation } from 'react-i18next';
import { downloadDocument } from '../../Helpers/applicantHelper';

const DocumentRow = ({ document, onStatusRefresh, onDeleteDocument }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="d-flex justify-content-between align-items-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="d-flex align-items-center">
        <div className="icon-link-effect" onClick={() => downloadDocument(document.url, document.title, t)}>
          <i className="fa fa-file-text mx-1"></i>
          {document.title}
        </div>
        <small className="text-muted d-flex align-items-center">
          <i className="fa fa-clock mx-1"></i>
          {moment(document.dateAdded).fromNow()}
        </small>
      </div>

      {isHovered && (
        <i
          id={`btnDeleteComment-${document.id}`}
          className="fa fa-trash far icon-hover-effect"
          onClick={() => onDeleteDocument(document.id)}
        />
      )}
    </div>
  );
};

export default DocumentRow;
